export default "__VITE_ASSET__KqVsmOwM__"